/**
 * Event helpers for when you add GA4 (gtag), Plausible, or similar.
 * No-op until `window.gtag` exists (load gtag in index.html or a tag manager).
 */
export function trackEvent(name, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params)
  }
}

export function trackOutboundBook(linkUrl) {
  trackEvent('book_consultation_click', { link_url: linkUrl, event_category: 'engagement' })
}
